import { ReactNode, useState } from "react";
import Sidebar from "./sidebar-new";  // Import our new sidebar component
import { UserAvatarDropdown } from "@/components/auth/UserAvatarDropdown";
import { EnvironmentBanner } from "./EnvironmentBanner";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar collapsed={sidebarCollapsed} />
      <div className="flex-1 flex flex-col overflow-hidden bg-background text-foreground">
        <header className="bg-card shadow-sm z-10">
          <div className="px-6 py-3 flex items-center justify-between">
            <div className="flex items-center">
              <Button
                variant="ghost"
                size="sm"
                onClick={toggleSidebar}
                className="mr-4"
                aria-label="Toggle sidebar"
              >
                <Menu className="h-5 w-5" />
              </Button>
              <h2 className="text-lg font-medium">Publishing Nexus</h2>
            </div>
            <UserAvatarDropdown />
          </div>
        </header>
        <EnvironmentBanner />
        <main className="flex-1 overflow-y-auto bg-background text-foreground">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
